import { Icon } from '@chakra-ui/icons';
import React from 'react';
import { DefaultIconProps } from '../IconType';

export const ButtonVector3 = ({
  opacity = 0.2,
  // If this is not set to auto (instead of 100%) then safari will force the <svg> to take up 100% width while the <path>s are centered w/in that space. This was an issue on the signup and login forms
  width = `auto`,
  height = `100%`,
  boxSize,
  variant = `small`,
  ...props
}: DefaultIconProps & { variant?: 'small' | 'height' | 'xheight' }) => {
  let viewBox = ``;
  let paths = null;
  switch (variant) {
    case `xheight`:
      viewBox = `0 0 54 200`;
      paths = (
        <path
          d="M49.686 0V84.8101M49.686 84.8101C52.0193 83.9662 53 79.2405 53 67.0886C53 54.9367 53 18.9873 53 2.53165M49.686 84.8101V94.9367V105.063M0.63623 200C0.63623 191.899 3.63623 188.186 6.13623 187.342H22.1362M22.1362 187.342H40.6362C45.0769 187.342 49.686 181.013 49.686 169.62V105.063M22.1362 187.342C22.4696 184.388 23.1 174.684 27.5 174.684C31.9 174.684 36.9696 174.684 40.6362 174.684C41.8029 174.684 45.1362 174.684 45.1362 165.823C45.1362 158.734 45.1362 134.177 45.1362 118.987C45.1694 115.612 47.7258 105.063 49.686 105.063"
          stroke="currentColor"
          strokeOpacity={opacity}
        />
      );
      break;
    case `height`:
      viewBox = `0 0 54 128`;
      paths = (
        <path
          d="M49.686 0V54.2785M49.686 54.2785C52.0193 53.7384 53 50.7139 53 42.9367C53 35.1595 53 12.1519 53 1.62025M49.686 54.2785V60.7595V67.2405M0.63623 128C0.63623 122.815 3.63623 120.439 6.13623 119.899H22.1362M22.1362 119.899H40.6362C45.0769 119.899 49.686 115.848 49.686 108.557V67.2405M22.1362 119.899C22.4696 118.008 23.1 111.797 27.5 111.797C31.9 111.797 36.9696 111.797 40.6362 111.797C41.8029 111.797 45.1362 111.797 45.1362 106.127C45.1362 101.59 45.1362 85.8734 45.1362 76.1519C45.1694 73.9916 47.7258 67.2405 49.686 67.2405"
          stroke="currentColor"
          strokeOpacity={opacity}
        />
      );
      break;
    case `small`:
    default:
      viewBox = `0 0 91 80`;
      paths = (
        <path
          d="M86.686 0.978027V34.478M86.686 34.478C89.0193 34.1447 90 32.278 90 27.478C90 22.678 90 8.47803 90 1.97803M86.686 34.478V38.478V42.478M1.13623 79.978C1.13623 76.778 6.13623 75.3114 8.63623 74.978H59.1362M59.1362 74.978H77.6362C82.0769 74.978 86.686 72.478 86.686 67.978V42.478M59.1362 74.978C59.4696 73.8114 60.1 69.978 64.5 69.978C68.9 69.978 73.9696 69.978 77.6362 69.978C78.8029 69.978 82.1362 69.978 82.1362 66.478C82.1362 63.678 82.1362 53.978 82.1362 47.978C82.1694 46.6447 84.7258 42.478 86.686 42.478"
          stroke="currentColor"
          strokeOpacity={opacity}
        />
      );
      break;
  }

  return (
    <Icon
      viewBox={viewBox}
      style={{
        ...(!boxSize && { width }),
        ...(!boxSize && { height }),
        fill: `none`,
      }}
      boxSize={boxSize}
      {...props}
    >
      {paths}
    </Icon>
  );
};

export default ButtonVector3;
